/*
 * The translation bundles: the base files plus one fragment per redesign area.
 *
 * Fragments exist so four parallel workstreams (entry, learning, family,
 * teacher) never edit the same JSON file. A fragment may add keys anywhere and
 * may override a base string; later fragments win. Merge the fragments back
 * into ar.json/en.json once the redesign has landed.
 */
import arBase from './locales/ar.json';
import enBase from './locales/en.json';
import arEntry from './locales/redesign/entry.ar.json';
import enEntry from './locales/redesign/entry.en.json';
import arLearning from './locales/redesign/learning.ar.json';
import enLearning from './locales/redesign/learning.en.json';
import arFamily from './locales/redesign/family.ar.json';
import enFamily from './locales/redesign/family.en.json';
import arTeacher from './locales/redesign/teacher.ar.json';
import enTeacher from './locales/redesign/teacher.en.json';
import arAdmin from './locales/redesign/admin.ar.json';
import enAdmin from './locales/redesign/admin.en.json';

type Bundle = Record<string, unknown>;

export function deepMerge(...parts: Bundle[]): Bundle {
  const out: Bundle = {};
  for (const part of parts) {
    for (const [k, v] of Object.entries(part)) {
      const prev = out[k];
      out[k] = v && typeof v === 'object' && !Array.isArray(v) && prev && typeof prev === 'object' && !Array.isArray(prev)
        ? deepMerge(prev as Bundle, v as Bundle)
        : v;
    }
  }
  return out;
}

export const ar = deepMerge(arBase, arEntry, arLearning, arFamily, arTeacher, arAdmin);
export const en = deepMerge(enBase, enEntry, enLearning, enFamily, enTeacher, enAdmin);
